/* This is ment to build provide a quick starting point when starting new index type file */
import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';
import itemGridStyle from './style';
import DSCGrid from './DSCGrid';
import MOBGrid from './MOBGrid';

export default function ItemGrid(props) {
	let style = itemGridStyle();
	let isMobile = useContext(GlobalContext).isMobile;

	return !isMobile ? <DSCGrid {...props} /> : <MOBGrid {...props} />;
}
